/**
 * API Configuration
 * Central configuration for API endpoints and settings
 */

// API Base URL
export const API_BASE_URL = '/api';

// Export for backward compatibility
export default { API_BASE_URL };
